import { gql } from '@apollo/client';
import { useMemo } from 'react';

import { UseMeDocument, UseMeQuery, UseMeQueryVariables } from './useMe.generated';
import { useQuery } from '@apollo/client';


const useMe = () => {
  const { data, loading, error } = useQuery<UseMeQuery, UseMeQueryVariables>(UseMeDocument);

  const operationPermissions = useMemo(() => {
    return data?.me?.userRole.operationPermissions.flatMap((permission) => permission.operations) ?? [];
  }, [data?.me?.userRole.operationPermissions]);
  const isManager =
    operationPermissions.includes('CMS') ||
    operationPermissions.includes('LMS') ||
    operationPermissions.includes('CRM');
  const isSupervisor = operationPermissions.includes('TUTOR');
  const isStudent = !isManager && operationPermissions.includes('STUDENT');

  return { me: data?.me, loading, operationPermissions, isStudent, isManager, isSupervisor };
};

export default useMe;

gql`
  query UseMe {
    me {
      id
      createdAt
      email
      name
      profileUrl
      phoneNumber
      sendbirdUserId
      userRole {
        id
        operationPermissions {
          domain
          operations
        }
      }
      organization {
        id
        name
        associatedOrganizations {
          id
          name
        }
      }
    }
  }
`;
